import { Row } from '@tanstack/react-table';
import classNames from 'classnames';

import { DateTimeHelper } from '@xemplo/date-time';
import { PayrunListItem, PayrunSteps } from '@xemplo/gp-types';

import type { MilestoneDateDiff } from '../payrun-base-table.helper';
import {
  getCurrentMilestone,
  getDateDiffFromMilestone,
} from '../payrun-base-table.helper';
import * as S from '../payrun-base-table.styles';

export const MilestoneDueDateCell = (props: Row<PayrunListItem>) => {
  const { original: payrun } = props;
  const activeStep = getCurrentMilestone(payrun);
  const dateDiff = getDateDiffFromMilestone(payrun);

  if (activeStep === PayrunSteps.Complete || activeStep === 'Draft') {
    return '-';
  }

  if (!DateTimeHelper.isValidDateValue(payrun.milestoneDueDateTimeUtc)) return '-';

  const dateTimeDisplay = DateTimeHelper.formatString(payrun.milestoneDueDateTimeUtc, {
    format: 'D MMM YYYY [at] h:mm A',
    isUtc: true,
    fallback: '-',
  });

  return (
    <S.MilestoneDueDateCellWrapper>
      <MilestoneText dateDiff={dateDiff} />
      <S.MilestoneDateSubtext>{dateTimeDisplay}</S.MilestoneDateSubtext>
    </S.MilestoneDueDateCellWrapper>
  );
};

export const MilestoneText = (props: { dateDiff: MilestoneDateDiff }) => {
  const { days, isPast } = props.dateDiff;

  if (days === 0 && isPast) {
    return <S.MilestoneDueDate className="overdue">Overdue today</S.MilestoneDueDate>;
  }
  if (days === 0) {
    return <S.MilestoneDueDate className="due">Due today</S.MilestoneDueDate>;
  }
  if (days === 1) {
    return <S.MilestoneDueDate className="due">Due tomorrow</S.MilestoneDueDate>;
  }
  if (days > 1) {
    return (
      <S.MilestoneDueDate className={classNames({ due: days < 7 })}>
        {`Due in ${days} days`}
      </S.MilestoneDueDate>
    );
  }

  const daysOverdue = Math.abs(days);
  const dayPlural = daysOverdue === 1 ? 'day' : 'days';
  return (
    <S.MilestoneDueDate className="overdue">
      {`${daysOverdue} ${dayPlural} overdue`}
    </S.MilestoneDueDate>
  );
};
